import { useEffect } from "react";

export const useTitle = (title: string) => {
	useEffect(() => {
		document.title = "Fyendal's Collection | " + title;
	}, [title]);
};
